import { css } from 'linaria';
import { styled } from 'linaria/react';

export const storageGalleryGrid = css`
  && {
    grid-gap: 24px;

    @media (--only-tablet) {
      grid-template-columns: repeat(2, 1fr);
      margin-bottom: 48px;
    }
  }
`;

export const storageGalleryGridWithCatalogLink = css`
  && {
    grid-template-rows: repeat(2, 1fr) 252px 104px auto;

    @media (--only-tablet) {
      grid-template-rows: repeat(2, 1fr) 112px 80px auto;
    }

    @media (--only-mobile) {
      grid-template-rows: repeat(4, 1fr) 376px 80px auto;
    }

    [data-position="3"] {
      @media (--from-tablet) {
        grid-row: 3 / 5;
      }
    }

    [data-position="4"] {
      @media (--from-tablet) {
        grid-column-start: 2;
        grid-row: 2 / 4;
        height: 656px;
      }

      @media (--only-tablet) {
        height: 352px;
      }

      @media (--only-mobile) {
        height: 376px;
      }
    }
  }
`

export const storageGalleryGridWithoutCatalogLink = css`
  && {
    grid-template-rows: auto;

    [data-position="4"] {
      @media (--from-tablet) {
        grid-column-start: 2;
        grid-row: 2 / 4;
        height: 784px;
      }

      @media (--only-tablet) {
        height: 456px;
      }

      @media (--only-mobile) {
        height: 372px;
      }
    }
  }
`

export const GalleryImageWrapper = styled.div`
  position: relative;
  height: 380px;
  cursor: pointer;

  @media (--to-desktop) {
    height: 216px;
  }
`;

export const galleryImage = css`
  width: 100%;
  height: 100%;
  margin: 0;
  border-radius: var(--rounding-l);
  object-fit: cover;
`;

export const galleryImageName = css`
  position: absolute;
  left: 16px;
  bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  padding: 8px 12px;
  background-color: rgb(0 0 0 / 15%);
  border-radius: var(--rounding-m);
  backdrop-filter: blur(40px);
`;

export const storageGalleryManual = css`
  position: relative;
  display: flex;
  align-items: center;
  padding: 24px;
  background-color: var(--background-secondary);
  border-radius: var(--rounding-l);

  @media (--to-desktop) {
    padding: 10px;
  }

  &:hover {
    background-color: var(--control-hover-minor);
  }
`;

export const storageGalleryManualText = css`
  @media (--only-tablet) {
    font-size: 14px;
    line-height: 20px;
  }
`;

export const storageGalleryManualTextWrapper = css`
  display: flex;
  max-width: 394px;
  column-gap: 12px;

  @media (--only-tablet) {
    width: 150px;
  }

  @media (--only-mobile) {
    width: 148px;
  }
`;

export const storageGalleryManualTextLogo = css`
  @media (--only-tablet) {
    width: 20px;
    height: 20px;
  }
`;

export const storageGalleryManualLogo = css`
  position: absolute;
  right: 16px;
  bottom: 0;
  width: 120px;
  height: 104px;
  object-fit: cover;

  @media (--only-tablet) {
    width: 92px;
    height: 72px;
  }

  @media (--only-mobile) {
    width: 92px;
    height: 80px;
  }
`;

export const storageGalleryButtonWrapper = css`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 32px;
`;
